import React from 'react';

const ACCENTS = {
  blue:  { border: 'border-t-2 border-[#0061B2]', iconBg: 'bg-[#0061B2]/8', iconText: 'text-[#0061B2]' },
  green: { border: 'border-t-2 border-[#027A48]', iconBg: 'bg-[#ECFDF3]',    iconText: 'text-[#027A48]' },
  red:   { border: 'border-t-2 border-[#B42318]', iconBg: 'bg-[#FEF3F2]',    iconText: 'text-[#B42318]' },
  amber: { border: 'border-t-2 border-[#B54708]', iconBg: 'bg-[#FFFAEB]',    iconText: 'text-[#B54708]' },
};

/**
 * Unified stat/summary card for all dashboard-style rows.
 * Replaces the local StatCard copies scattered across StockSummary, Marketing, etc.
 */
const StatCard = ({ label, value, sub, icon, accent = 'blue', className = '' }) => {
  const { border, iconBg, iconText } = ACCENTS[accent] || ACCENTS.blue;
  return (
    <div className={`rounded-xl bg-white border border-[#E9EDF6] p-4 shadow-sm ${border} ${className}`}>
      <div className="flex items-start justify-between gap-2">
        <span className="text-xs font-medium uppercase tracking-wide text-[#637381]">{label}</span>
        {icon && (
          <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${iconBg} ${iconText}`}>
            {React.isValidElement(icon)
              ? React.cloneElement(icon, { className: 'h-4 w-4' })
              : icon}
          </div>
        )}
      </div>
      <p className="mt-2 text-2xl font-bold text-[#212B36] leading-tight">{value ?? '—'}</p>
      {sub && <p className="mt-0.5 text-xs text-[#637381]">{sub}</p>}
    </div>
  );
};

export default StatCard;
